/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */

import React from 'react';
import {withRouter} from 'react-router';

import moment from 'moment';
import {Button, Col, Glyphicon, Grid, Row} from 'react-bootstrap';
import ReactSpinner from 'react-spinjs';
import AddUserView from './addUserView.react';
import UserStore from '../../../stores/UserStore';
import DealerStore from '../../../stores/DealerStore';
import APIActions from '../../../actions/apiActions';
import UIHelpers from '../../../library/UIHelpers';
import AppConstants from '../../../constants/AppConstants';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import UserAPI from "../../../api/awsUserAPI";


class ManageUsersView extends React.Component {
    constructor(props) {
        console.log("[ManageUsersView] - initialisation");

        super(props);

        this.addNewUser = this.addNewUser.bind(this);
        this.actionEdit = this.actionEdit.bind(this);
        this.userEditHandler = this.userEditHandler.bind(this);
        this.loadUsers = this.loadUsers.bind(this);
        this.deleteUser = this.deleteUser.bind(this) ;
        this.passwordUpdate = this.passwordUpdate.bind(this) ;

        this._onUserChange = this._onUserChange.bind(this);

        this.state = {
            activeTab : 1,
            jobNames: null,
            addingUser : false,
            loading : false,
            users : [],
            editingUser : null
        };
    }

   componentDidMount() {
        console.log("[ManageUsersView] - componentDidMount");
        UserStore.addChangeListener(this._onUserChange) ;
        this.loadUsers() ;
    }

    componentWillUnmount() {
        console.log("[ManageUsersView] - componentWillUnmount");
        UserStore.removeChangeListener(this._onUserChange) ;
    }

    addDealerAttributes(userList) {
        let d = DealerStore.dealers();
        console.log("ATTS dealers=", d);
        var dealerMap = d.reduce(function (dm, dl) {
            dm[dl.dealerId] = dl.name ;
            return dm ;
        }, {});

        console.log("ATTS mapping=", dealerMap);

        let sortUser = (u1,u2) => u1.name.localeCompare(u2.name) ;

        let r = userList.sort(sortUser).map((u) => {
            if (u.role === AppConstants.ROLE_DEALER) {
                u.dealerName = dealerMap[u.dealerId] || "N/A";
            }
            else {
                u.dealerName = undefined ;
            }

            return u ;
        });

        return r ;
    }

    _onUserChange() {
        var s = this.state ;
        s.users = this.addDealerAttributes(UserStore.users()) ;
        console.log("[ManageUsersView] - userList=", s.users);
        s.loading = false ;
        this.setState(s);
    }

    loadUsers() {
        var s = this.state ;
        s.loading = true ;
        this.setState(s);
        APIActions.allUsers() ;
    }

    addNewUser() {
        console.log("Add new user");
        var s = this.state ;
        s.addingUser = !s.addingUser ;
        this.setState(s);
    }


    actionEdit(u) {
        console.log("[USER] - edit user: " + JSON.stringify(u));
        var s = this.state ;
        s.editingUser = u ;
        s.addingUser = true ;
        this.setState(s);
    }

    resetPassword(u) {
        console.log("[USER] - password reset user: " + JSON.stringify(u));
       // TODO
    }

    userEditHandler(state) {
        var s = this.state ;
        s.addingUser = false ;
        s.editingUser = null ;
        this.setState(s);

        this.loadUsers();
    }

    handleTypeSelect(eventKey) {
        eventKey.preventDefault();
        var s = this.state ;
        s.activeTab = eventKey ;
        this.setState(s);
    }

    timeFormatter(cell, row) {
        if (!cell) {
            return "";
        }
        return moment.utc(cell, 'YYYYMMDDHHmmss').local().format("lll");
    }

    async deleteUser(user) {
        console.log("Delete User: ", user) ;
        if (!UIHelpers.confirmAction("Are you sure you want to delete this user?")) {
            return ;
        }

        try {
            let result = await UserAPI.deleteUser(user) ;
            console.log("Delete user result = ", result) ;
            this.loadUsers();
        }
        catch(e) {
            console.log("Error deleting user: ", e.message) ;
        }
    }

    async passwordUpdate(user) {
        console.log("Delete User: ", user) ;
        let newPassword = UIHelpers.promptAction("Enter a new password (min 8 chars, mixed upper/lower case") ;

        if (!newPassword) {
            return ;
        }

        if (newPassword === "" || newPassword.length < 8) {
            alert("The password entered did not meet the required password policy criteria");
            return ;
        }

        try {
            let result = await UserAPI.updateUserPassword(user.email, newPassword) ;
            alert("User password updated");
        }
        catch(e) {
            alert("A problem occurred updating the password - please retry or contact support");
        }
    }

    cellButton(cell, row, enumObject, rowIndex) {
        return (
            <div>
                <Button bsStyle="danger" bsSize="xsmall" title="Delete User" onClick={() => this.deleteUser(row)}><Glyphicon glyph="trash"/></Button>{'  '}
                <Button bsStyle="info" bsSize="xsmall" title="Edit User" onClick={this.actionEdit.bind(this,row)}><Glyphicon glyph="edit"/></Button>{'  '}
                <Button bsStyle="info" bsSize="xsmall" title="Password Reset" onClick={() => this.passwordUpdate(row)}><Glyphicon glyph="user"/></Button>{'  '}
            </div>
        );
    }

    render() {
        const selectRowProp = {
            bgColor: 'lightblue'
        };

        const options = {
            sortName: 'name',  // default sort column name
            sortOrder: 'asc',  // default sort order
            sizePerPage: 15,
            hideSizePerPage: true,
        };

        var userList = this.state.users || [];
        var self = this ;
        return (
            <div>
                <Grid>
                    <Row hidden={this.state.addingUser}>
                        <Col>
                            <Button bsStyle="success" bsSize="small" onClick={this.loadUsers}><Glyphicon glyph="refresh"/>{' '}Refresh Users</Button>{' '}
                            <Button bsStyle="success" bsSize="small" onClick={this.addNewUser}><Glyphicon glyph="plus"/>{' '}Add User</Button>{'   '}

                        </Col>
                    </Row>
                    <Row ><Col><br /></Col></Row>
                    <Row hidden={!this.state.addingUser}>
                        <Col>
                            <AddUserView closeHandler={this.userEditHandler} user={this.state.editingUser}/>
                        </Col>
                    </Row>

                    <Row hidden={this.state.addingUser}>

                        <BootstrapTable data={ userList }
                            selectRow={ selectRowProp }
                            options={ options }
                            hover focus search pagination
                            tableContainerClass='orbit-table-container'>

                            <TableHeaderColumn dataField='userId' hidden={true} isKey >ID</TableHeaderColumn>
                            <TableHeaderColumn dataField='email' tdStyle={ { whiteSpace: 'normal' } }>Email</TableHeaderColumn>
                            <TableHeaderColumn dataField='name' tdStyle={ { whiteSpace: 'normal' } }>Name</TableHeaderColumn>
                            <TableHeaderColumn dataField='role' >Role</TableHeaderColumn>
                            <TableHeaderColumn dataField='dealerName' tdStyle={ { whiteSpace: 'normal' } }>Dealer Name</TableHeaderColumn>
                            <TableHeaderColumn dataField='lastAccess' dataFormat={ this.timeFormatter } >Last Login</TableHeaderColumn>
                            <TableHeaderColumn dataField='button' width='90px' dataFormat={this.cellButton.bind(this)}></TableHeaderColumn>
                        </BootstrapTable>
                    </Row>
                     <Row>
                        <Col>
                        </Col>
                    </Row>
                    <Row hidden={!this.state.loading}>
                        <ReactSpinner/>
                    </Row>
                </Grid>
            </div>
        );
    }
}

export default withRouter(ManageUsersView);



// WEBPACK FOOTER //
// ./src/app/components/admin/user/manageUsersView.js